import { cx } from "../cx";
import styles from "./Divider.module.css";

export interface DividerProps {
  orientation?: "horizontal" | "vertical";
  /** Clockify's dotted column separators in entry rows. */
  dotted?: boolean;
  className?: string;
}

export function Divider({ orientation = "horizontal", dotted, className }: DividerProps) {
  return (
    <hr
      aria-orientation={orientation}
      className={cx(styles.divider, styles[orientation], dotted && styles.dotted, className)}
    />
  );
}
